import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { AppDispatch, RootState } from './store';

// Typed versions of the react-redux hooks: use these in new code instead of
// `useSelector((state: RootState) => ...)` and a bare `useDispatch()`.
// Wrappers rather than `useSelector.withTypes()`: they read the react-redux
// hooks when called, not at import, so the ~50 tests that mock react-redux
// with a partial factory keep working.

/** `useSelector` typed with the app's `RootState`. */
export const useAppSelector: TypedUseSelectorHook<RootState> = (
  selector,
  equalityFnOrOptions
) => useSelector(selector, equalityFnOrOptions);

/** `useDispatch` typed with the app's `AppDispatch` (thunks included). */
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
